import { render, staticRenderFns } from "./TaskCard.vue?vue&type=template&id=970071ec&scoped=true"
import script from "./TaskCard.vue?vue&type=script&lang=js"
export * from "./TaskCard.vue?vue&type=script&lang=js"
import style0 from "./TaskCard.vue?vue&type=style&index=0&id=970071ec&prod&lang=scss&scoped=true"
import style1 from "./TaskCard.vue?vue&type=style&index=1&id=970071ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970071ec",
  null
  
)

export default component.exports